angular.module('flipto.components.common.tasks')
    .config(['$provide', '$compileProvider',
        function ($provide, $compileProvider) {
            $compileProvider.directive('ftHideWhileTaskPending', ['ftTasks', function (ftTasks) {

                return function (scope, elem, attrs) {
                    var taskScope = {};
                    taskScope.taskName = attrs.ftHideWhileTaskPending;

                    attrs.$observe('ftHideWhileTaskPending', function (newTaskName) {
                        taskScope.taskName = newTaskName;
                    });

                    scope.$watch(function () {
                        return ftTasks.isPending(taskScope.taskName);
                    }, function (isPending) {
                        elem[!!isPending ? 'addClass' : 'removeClass']('ng-hide');
                    });
                };

            }]);
        }
    ]);